<template>
    <v-dialog v-model="dialogFiltro">
        <Filtros :mobile="true" :marcas="marcas" :grupos="grupos" :subgrupos="subgrupos" :skus="skus" class="pt-6" />
    </v-dialog>
</template>

<script>
import Filtros from './Filtros.vue'
export default {
	props: {
		dialog: Boolean ,
		marcas: {},
		grupos: {},
		subgrupos: {},
		skus: {},
	},
    components:{
        Filtros
    },
	data() {
		return {
		}
	},
    computed: {
		dialogFiltro: {
			get() {
				return this.dialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
    methods: {

		click() {
			this.dialogClose()
		},
		dialogClose() {
			this.$emit('dialogClose')
		}
    }
}
</script>